(() => {
  if (window.__arteeqSmartCartCountSync) return;
  window.__arteeqSmartCartCountSync = true;

  let timer;
  let attributeSyncInFlight = false;

  const renderCount = (count) => {
    document.querySelectorAll('.cart-bubble__text-count').forEach((node) => {
      node.textContent = count;
    });

    document.querySelectorAll('.cart-bubble').forEach((bubble) => {
      bubble.hidden = count === 0;
    });

    document.querySelectorAll('a[aria-label][href*="/cart"]').forEach((link) => {
      link.setAttribute('aria-label', `Cart (${count})`);
    });
  };

  const itemIsCustomized = (item) => {
    const personalization = (item.options_with_values || []).find((option) =>
      /personalization/i.test(String(option.name || ''))
    );

    if (personalization) {
      const value = String(personalization.value || '').trim();
      return value !== '' && !/^standard$/i.test(value);
    }

    return Object.entries(item.properties || {}).some(([key, value]) =>
      /custom\s*(name|number)/i.test(key) && String(value || '').trim() !== ''
    );
  };

  const syncCustomizationAttribute = (cart) => {
    if (attributeSyncInFlight) return;

    const desiredValue = (cart.items || []).some(itemIsCustomized) ? 'true' : '';
    const currentValue =
      String((cart.attributes || {}).has_customization || '').toLowerCase() === 'true'
        ? 'true'
        : '';

    if (desiredValue === currentValue) return;

    attributeSyncInFlight = true;
    originalFetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { has_customization: desiredValue || null }
      })
    })
      .then((response) => response.ok ? response.json() : null)
      .then((updatedCart) => {
        if (updatedCart && Number.isFinite(updatedCart.item_count)) {
          renderCount(updatedCart.item_count);
        }
      })
      .catch(() => {})
      .finally(() => {
        attributeSyncInFlight = false;
      });
  };

  const refreshCount = () => {
    window.fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then((response) => response.ok ? response.json() : null)
      .then((cart) => {
        if (cart && Number.isFinite(cart.item_count)) {
          renderCount(cart.item_count);
          syncCustomizationAttribute(cart);
        }
      })
      .catch(() => {});
  };

  const scheduleRefresh = (delay = 500) => {
    window.clearTimeout(timer);
    timer = window.setTimeout(refreshCount, delay);
  };

  const originalFetch = window.fetch.bind(window);
  window.fetch = (...args) => {
    const request = originalFetch(...args);
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';

    if (/\/cart\/(add|change|update|clear)\.js(?:\?|$)/.test(url)) {
      request.finally(() => scheduleRefresh(150));
    }

    return request;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this.addEventListener('loadend', () => {
      if (/\/cart\/(add|change|update|clear)\.js(?:\?|$)/.test(String(url))) {
        scheduleRefresh(150);
      }
    });
    return originalOpen.call(this, method, url, ...rest);
  };

  document.addEventListener('click', (event) => {
    if (!event.target.closest('button')) return;
    scheduleRefresh(700);
  }, true);

  document.addEventListener('change', () => scheduleRefresh(500), true);
  window.addEventListener('focus', () => scheduleRefresh(100));

  refreshCount();
})();
